import { render, staticRenderFns } from "./QuoteList.vue?vue&type=template&id=2f6f130a&scoped=true"
import script from "./QuoteList.vue?vue&type=script&lang=js"
export * from "./QuoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f130a",
  null
  
)

export default component.exports